import React from 'react'
import './contact-us.css'
import Hero from './components/Hero'
import ContactDetails from './components/ContactDetails'

const ContactUs = () => {
  return (
    <>
      <Hero />
      <ContactDetails />
    </>
  )
}

export default ContactUs